var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn h-100 admin-container"},[_c('div',{staticClass:"page-content"},[_c('SectionTitle',{attrs:{"title":'Bản đồ chuyên đề'}}),_c('FloodMap',{attrs:{"showReportButton":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }